import type { IconData } from '@stacksjs/iconify-core'

export const earth2Remix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.556 25.491Q4.5 24.752 4.5 24C4.5 13.23 13.23 4.5 24 4.5c5.028 0 9.612 1.903 13.07 5.028c-3.932.835-7.62 1.822-9.939 2.476c-1.773.501-3.62 1.61-4.367 3.59a11.4 11.4 0 0 0-.553 2.024c-.627 3.52 2.266 6.066 5.244 6.856l2.47.655a2.1 2.1 0 0 1 1.327 1.112c1.124 2.3 3.797 7.374 7.154 10.902A19.45 19.45 0 0 1 24 43.5a19.4 19.4 0 0 1-6.84-1.234a39 39 0 0 0 2.03-5.916c.278-1.097.218-2.27-.259-3.342c-.843-1.893-2.86-5.548-6.503-6.884a4.8 4.8 0 0 0-1.077-.249a57 57 0 0 0-6.795-.384M.5 24C.5 36.979 11.021 47.5 24 47.5S47.5 36.979 47.5 24S36.979.5 24 .5S.5 11.021.5 24\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default earth2Remix
